// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2875":"b4681b27a6ba5eca","6202":"1cf220a4e2c990ad","8958":"f728b8269a233cb4"}[chunkId] + ".js";
};